export default __webpack_public_path__ + "static/media/login-form.01d7c8db.jpg";